import axios from 'axios'

import { withGenericErrorHandling } from '../api'

export type DynamicDataOptions = {
  dynamicData: Record<string, string>
  dynamicDataSections: string[]
}

export interface AssetClient {
  getAsset: (path: string, dynamicDataOptions?: DynamicDataOptions) => Promise<string>
}

export const createAssetClient = (): AssetClient => {
  const instance = axios.create({
    responseType: 'document',
  })

  const getAsset = async (
    path: string,
    dynamicDataOptions?: DynamicDataOptions,
  ): Promise<string> => {
    const res = await withGenericErrorHandling(() => instance.get(path))
    if (res.status !== 200) return res.statusText

    const assetDocument = res.data as Document

    if (dynamicDataOptions) {
      setDynamicData(assetDocument, dynamicDataOptions)
    }

    const base = assetDocument.createElement('base')
    base.href = path
    assetDocument.head.prepend(base)
    return assetDocument.documentElement.outerHTML
  }

  return {
    getAsset,
  }
}

export function setDynamicData(
  assetDocument: Document,
  { dynamicData, dynamicDataSections }: DynamicDataOptions,
) {
  const sectionElements = assetDocument.querySelectorAll<HTMLElement>(
    '[data-dynamic-section]',
  )

  sectionElements.forEach((el) => {
    const section = el.getAttribute('data-dynamic-section')
    if (section && dynamicDataSections.includes(section)) {
      el.hidden = false
    }
  })

  const dynamicDataElements = assetDocument.querySelectorAll('[data-dynamic]')
  dynamicDataElements.forEach((el) => {
    const key = el.getAttribute('data-dynamic')
    if (key && key in dynamicData) {
      el.textContent = dynamicData[key]
    }
  })
}
